import styled from 'styled-components'

const Bound = styled.div`
    display: flex;
    width: 100%;
`
export { Bound }